import { defineComponent } from 'vue';
import applyPageI18NMessages from '@/vue-utils/i18n';
import translation from '@/assets/rawData/i18n/screener.json';
export default defineComponent({
    name: 'ProgressBar',
    props: {
        finalEvent: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            progress: 0,
            intervalId: null
        };
    },
    watch: {
        finalEvent(newVal) {
            if (newVal) {
                this.setFinalProgress();
            }
        }
    },
    mounted() {
        applyPageI18NMessages(this, 'screener', translation);
        this.startProgress();
        this.$refs.progressBar.addEventListener('transitionend', this.onTransitionEnd);
    },
    beforeDestroy() {
        clearTimeout(this.intervalId);
        this.$refs.progressBar.removeEventListener('transitionend', this.onTransitionEnd);
    },
    methods: {
        startProgress() {
            const startTime = Date.now();
            const updateProgress = () => {
                const elapsed = Date.now() - startTime;
                if (elapsed >= 8000) {
                    this.progress = 90;
                }
                else if (elapsed >= 3000) {
                    this.progress = 30;
                }
                else {
                    this.progress = (elapsed / 3000) * 30;
                }
                if (this.progress < 60) {
                    this.timeoutId = setTimeout(updateProgress, 100);
                }
            };
            this.timeoutId = setTimeout(updateProgress, 100);
        },
        setFinalProgress() {
            clearTimeout(this.timeoutId);
            this.progress = 100;
        },
        onTransitionEnd(event) {
            if (event.propertyName === 'width' && this.progress === 100) {
                this.$emit('progress-complete');
            }
        }
    }
});
